import React from "react";
import "./TopNav.css";
import { Link, useLocation } from "react-router-dom";

function TopNav() {
	const location = useLocation();

	return (
		<nav className="topnav">
      {/*<img*/}
      {/*  src="https://prowly-uploads.s3.eu-west-1.amazonaws.com/uploads/1036/assets/56130/Spotify_Logo_CMYK_Green.png"*/}
      {/*  alt="spotify logo"*/}
      {/*  width={100}*/}
      {/*/>*/}

			<Link 
				to="/" 
				className={`topnav__link ${location.pathname === "/" ? "active" : ""}`}
			>
				Player
			</Link>
			{/*<Link */}
			{/*	to="/search" */}
			{/*	className={`topnav__link ${location.pathname === "/search" ? "active" : ""}`}*/}
			{/*>*/}
			{/*	Search*/}
			{/*</Link>*/}
			{/*<Link */}
			{/*	to="/library" */}
			{/*	className={`topnav__link ${location.pathname === "/library" ? "active" : ""}`}*/}
			{/*>*/}
			{/*	Library*/}
			{/*</Link>*/}
			<Link 
				to="/submission" 
				className={`topnav__link ${location.pathname === "/submission" ? "active" : ""}`}
			>
				Submit Track
			</Link>
		</nav>
	);
}

export default TopNav;


